import {
  Grid,
  Typography
} from '@material-ui/core';
import React from 'react';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import VoxelDialog from '../../voxel/Dialogs/VoxelDialog';
import VoxelDialogActionButton from '../../voxel/Dialogs/VoxelDialogActionButton';
import VoxelDialogActions from '../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../voxel/Dialogs/VoxelDialogContent';
import ProgressBar from '../Progress/ProgressBar';

export interface TranslateInProgressDialogProps {
  projectId: number;
  closeDialog: () => void;
  goToProject: () => void;
}

const TranslateInProgressDialog: React.FC<TranslateInProgressDialogProps> = ({
  projectId,
  closeDialog,
  goToProject,
}) => {
  const progressQuery = projectsApiService.queries.useGetCopyProgress(projectId, {
    pollInterval: 350,
  });

  const projectQuery = projectsApiService.queries.useGetProject(
    { id: projectId },
    {
      pollInterval: 350,
    }
  );

  if (!progressQuery?.result || !projectQuery?.result) {
    return null;
  }

  return (
    <VoxelDialog open={true} onClose={closeDialog} title='Translating project'>
      <VoxelDialogContent>
        <Grid container>
          <Grid item xs={12}>
            {progressQuery.result.totalKeywordsCount === 0 && (
              <>
                <Typography>Translate progress</Typography>
                <ProgressBar current={!projectQuery.result.copyInProgress ? 1 : 0} total={1} />
              </>
            )}
            {progressQuery.result.totalKeywordsCount > 0 && (
              <>
                <Typography>Keyword progress</Typography>
                <ProgressBar
                  current={progressQuery.result.completedKeywordsCount}
                  total={progressQuery.result.totalKeywordsCount}
                />
              </>
            )}
          </Grid>
        </Grid>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionButton onClick={goToProject} disabled={projectQuery.result.translateInProgress} title={'Continue to project'} />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default TranslateInProgressDialog;
